import * as React from 'react'
import ProjectExpensesFiltersForm from './additional_reports/by_type/project_expenses'
import TrackedClicksFilterForm from './additional_reports/by_type/tracked_clicks'

const FORMS = {
  'project_expenses': ProjectExpensesFiltersForm,
  'tracked_clicks': TrackedClicksFilterForm,
}

type FormByTypeProps = {
  type: string,
  data: any
}

export default function FormByType(props: FormByTypeProps) {
  const { type, data } = props
  const CurrentForm = FORMS[type]

  return (
    <div className="form-by-type">
      <CurrentForm formData={ data } />
    </div>
  )
}
